import {
  FETCH_EMPLOYEE_DETAILS_REQUEST,
  FETCH_EMPLOYEE_DETAILS_SUCCESS,
  FETCH_EMPLOYEE_DETAILS_FAILURE,
  FETCH_EMPLOYEE_OTHER_INFO_REQUEST,
  FETCH_EMPLOYEE_OTHER_INFO_SUCCESS,
  FETCH_EMPLOYEE_OTHER_INFO_FAILURE,
  FETCH_EMPLOYEE_NO_PAY_REQUEST,
  FETCH_EMPLOYEE_NO_PAY_SUCCESS,
  FETCH_EMPLOYEE_NO_PAY_FAILURE,
  FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_REQUEST,
  FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_SUCCESS,
  FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_FAILURE,
  FETCH_EMPLOYEE_LIST_REQUEST,
  FETCH_EMPLOYEE_LIST_SUCCESS,
  FETCH_EMPLOYEE_LIST_FAILURE,
  CLEAR_EMPLOYEE_DETAILS,
} from "../constants/EmpDetailsConstants";

const initialState = {
  employeeList: [],
  employeeListLoading: false,
  employeeListError: null,

  employeeDetails: {},
  employeeDetailsLoading: false,
  employeeDetailsError: null,

  employeeOtherInfo: [],
  employeeOtherInfoLoading: false,
  employeeOtherInfoError: null,

  employeeNoPay: [],
  employeeNoPayLoading: false,
  employeeNoPayError: null,

  employeePreYearSummary: [],
  employeePreYearSummaryLoading: false,
  employeePreYearSummaryError: null,
};

export const empDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMPLOYEE_DETAILS_REQUEST:
      return { ...state, employeeDetailsLoading: true, employeeDetailsError: null };
    case FETCH_EMPLOYEE_DETAILS_SUCCESS:
      return { ...state, employeeDetails: action.payload || {}, employeeDetailsLoading: false };
    case FETCH_EMPLOYEE_DETAILS_FAILURE:
      return { ...state, employeeDetailsError: action.payload, employeeDetailsLoading: false };

    case FETCH_EMPLOYEE_OTHER_INFO_REQUEST:
      return { ...state, employeeOtherInfoLoading: true, employeeOtherInfoError: null };
    case FETCH_EMPLOYEE_OTHER_INFO_SUCCESS:
      return { ...state, employeeOtherInfo: action.payload || [], employeeOtherInfoLoading: false };
    case FETCH_EMPLOYEE_OTHER_INFO_FAILURE:
      return { ...state, employeeOtherInfoError: action.payload, employeeOtherInfoLoading: false };

    case FETCH_EMPLOYEE_NO_PAY_REQUEST:
      return { ...state, employeeNoPayLoading: true, employeeNoPayError: null };
    case FETCH_EMPLOYEE_NO_PAY_SUCCESS:
      return { ...state, employeeNoPay: action.payload || [], employeeNoPayLoading: false };
    case FETCH_EMPLOYEE_NO_PAY_FAILURE:
      return { ...state, employeeNoPayError: action.payload, employeeNoPayLoading: false };

    case FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_REQUEST:
      return { ...state, employeePreYearSummaryLoading: true, employeePreYearSummaryError: null };
    case FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_SUCCESS:
      return { ...state, employeePreYearSummary: action.payload || [], employeePreYearSummaryLoading: false };
    case FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_FAILURE:
      return { ...state, employeePreYearSummaryError: action.payload, employeePreYearSummaryLoading: false };

    case FETCH_EMPLOYEE_LIST_REQUEST:
      return { ...state, employeeListLoading: true, employeeListError: null };
    case FETCH_EMPLOYEE_LIST_SUCCESS:
      return { ...state, employeeList: action.payload || [], employeeListLoading: false };
    case FETCH_EMPLOYEE_LIST_FAILURE:
      return { ...state, employeeListError: action.payload, employeeListLoading: false };

    case CLEAR_EMPLOYEE_DETAILS:
      return initialState;

    default:
      return state;
  }
};
